const state = {
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/favourites/state.js